const TYPE_LABELS = Object.freeze({
  unit_discount: "Remise unitaire",
  category_discount: "Remise par catégorie",
  case_pack_discount: "Remise au colisage",
  until_case_pack_minus_one_discount: "Remise jusqu’à colisage - 1",
  tier_discount: "Remise par paliers",
  free_unit: "Unités offertes",
});

const FIELD_LABELS = Object.freeze({
  rate: "Remise",
  category: "Catégorie",
  buy_quantity: "Quantité achetée",
  free_quantity: "Quantité offerte",
  min_quantity: "Quantité minimale",
  max_quantity: "Quantité maximale",
});

export function getCommercialRuleTypeLabel(ruleType) {
  return TYPE_LABELS[ruleType] || ruleType || "Type inconnu";
}

function formatNumber(value) {
  const number = Number(value);
  return Number.isFinite(number)
    ? new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 2 }).format(number)
    : String(value);
}

function formatTier(tier, index) {
  if (!tier || typeof tier !== "object" || Array.isArray(tier)) {
    return `Palier ${index + 1} : ${String(tier)}`;
  }
  const parts = [];
  if (tier.min_quantity !== undefined) parts.push(`dès ${tier.min_quantity}`);
  if (tier.max_quantity !== undefined) parts.push(`jusqu’à ${tier.max_quantity}`);
  if (tier.rate !== undefined) parts.push(`${formatNumber(tier.rate)} %`);
  return `Palier ${index + 1} : ${parts.join(" — ") || "—"}`;
}

export function formatCommercialRuleConfiguration(rule) {
  const configuration = rule?.configuration;
  if (!configuration || typeof configuration !== "object" || Array.isArray(configuration)) {
    return ["Configuration indisponible"];
  }

  const lines = [];
  Object.entries(configuration).forEach(([key, value]) => {
    if (key === "tiers" && Array.isArray(value)) {
      value.forEach((tier, index) => lines.push(formatTier(tier, index)));
      return;
    }

    const label = FIELD_LABELS[key] || key;
    if (key === "rate") {
      lines.push(`${label} : ${formatNumber(value)} %`);
    } else if (value && typeof value === "object") {
      lines.push(`${label} : ${JSON.stringify(value)}`);
    } else if (typeof value === "boolean") {
      lines.push(`${label} : ${value ? "Oui" : "Non"}`);
    } else {
      lines.push(`${label} : ${value ?? "—"}`);
    }
  });

  return lines.length ? lines : ["Aucun paramètre"];
}
